export default "__VITE_ASSET__B8AKu8Ky__"